"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("@lingui/react");

var _react2 = _interopRequireDefault(require("react"));

var _blocks = require("@bueno/blocks");

var _utils = require("../../utils");

var _toFixed = require("../../../../utils/toFixed");

const PriorityGroupRow = props => {
  const {
    latestLabel,
    site,
    priority,
    severity,
    ruleName,
    ruleType,
    hits,
    activeHits,
    averageDur,
    activeAverageDur,
    actionsCount,
    showSnoozed
  } = props;
  const displayHits = showSnoozed ? hits : activeHits;
  const displayAverageDur = showSnoozed ? averageDur : activeAverageDur;
  const {
    Cell,
    MainText,
    allAssociated,
    displayTargetCount
  } = (0, _utils.getActionsAssociatedState)(props, showSnoozed);
  return /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, null, /*#__PURE__*/_react2.default.createElement(Cell, null, /*#__PURE__*/_react2.default.createElement(MainText, null, latestLabel)), /*#__PURE__*/_react2.default.createElement(Cell, null, /*#__PURE__*/_react2.default.createElement(MainText, null, priority === 0 ? '' : priority)), /*#__PURE__*/_react2.default.createElement(Cell, null, /*#__PURE__*/_react2.default.createElement(MainText, null, site.label)), /*#__PURE__*/_react2.default.createElement(Cell, null, /*#__PURE__*/_react2.default.createElement(MainText, null, site.state)), /*#__PURE__*/_react2.default.createElement(Cell, null, /*#__PURE__*/_react2.default.createElement(MainText, null, severity)), /*#__PURE__*/_react2.default.createElement(Cell, null, /*#__PURE__*/_react2.default.createElement(MainText, null, ruleName)), /*#__PURE__*/_react2.default.createElement(Cell, null, /*#__PURE__*/_react2.default.createElement(MainText, null, ruleType)), /*#__PURE__*/_react2.default.createElement(Cell, null, /*#__PURE__*/_react2.default.createElement(MainText, null, allAssociated ? `All Associated (${displayTargetCount})` : /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "{displayTargetCount, plural, one {{displayTargetCount} Equip} other {{displayTargetCount} Equips}}",
    values: {
      displayTargetCount: displayTargetCount
    }
  })), actionsCount > 0 && /*#__PURE__*/_react2.default.createElement(_blocks.Supportive, null, actionsCount, " Associated")), /*#__PURE__*/_react2.default.createElement(Cell, null, /*#__PURE__*/_react2.default.createElement(MainText, null, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "{displayHits, plural, one {{displayHits} Hit} other {{displayHits} Hits}}",
    values: {
      displayHits: displayHits
    }
  })), /*#__PURE__*/_react2.default.createElement(_blocks.Supportive, null, "Avg. ", (0, _toFixed.toFixed)(displayAverageDur, 2), "hrs")));
};

var _default = /*#__PURE__*/_react2.default.memo(PriorityGroupRow);

exports.default = _default;
module.exports = exports.default;